var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderIntegration?.id && _vm.orderIntegration?.status == 'failed')?_c('div',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mdi mdi-sync-circle text-primary pointer",attrs:{"title":'Click para intentar el envío nuevamente'},on:{"click":function($event){return _vm.resync()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }